import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const AreaConfiguration = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <Text>{t("common.underConstruction")}</Text>
    </Container>
  );
};

const Container = styled.div`
  text-align: center;
  padding: 185px 0;
`;

const Text = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: "#495057";
`;

export default AreaConfiguration;
